<template>
    <div>
        <div v-if="!model.isMultiDropdown">
            <kendo-dropdownlist
                v-if="loaded"
                :id="'dropdown' + _uid"
                :name="'dropdown' + _uid"
                v-model="selectedId"
                :data-vv-as="fieldName"
                v-validate="required ? 'required' : ''"
                :data-source="items"
                :data-text-field="'text'"
                :data-value-field="'id'"
                :filter="filterPattern"
                :disabled="details || model.isReadOnly"
                :optionLabel="optionLabel ? optionLabel : $t('choose')"
                :footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
                :height="height"
                style="width: 100%;"
            ></kendo-dropdownlist>

            <DropdownSettings
                v-if="loaded"
                :filterPattern.sync="filterPattern"
                :show.sync="showSettings"
            ></DropdownSettings>
        </div>
        <div v-if="model.isMultiDropdown">
            <dynamic-register-multi-select
                v-model="model.fieldValue.textValue"
                :details="details"
                :model="model"
                :required="required"
                :fieldName="fieldName"
                :height="height"
            ></dynamic-register-multi-select>
        </div>
        <span
            class="text-danger col-12"
            v-if="errors.has('dropdown' + _uid)"
        >{{ errors.first('dropdown' + _uid) }}</span>
    </div>
</template>

<script>
import Vue from "vue";
import DynamicRegisterMultiSelect from "../dynamic/DynamicRegisterMultiSelect";
import FooterTemplate from "../../components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "../../components/common/DropdownSettings";
import { mapGetters } from "vuex";
import { RegisterEventBus } from '@/buses/register-bus.js';

export default {
    inject: ["$validator"],
    props: {
        value: [String, Number],
        model: Object,
        optionLabel: Object,
        details: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        fieldName: {
            type: String,
            required: false,
            default: "Unknown",
        },
        height: {
            type: Number,
            default: 400, // 200 - Default value for Kendo DropdownList
        }
    },
    components: {
        "dynamic-register-multi-select": DynamicRegisterMultiSelect,
        DropdownSettings,
    },
    data() {
        return {
            selectedId: this.value || "",
            items: [],
            loaded: false,
            showSettings: false,
            filterPattern: "",
        };
    },
    methods: {
        loadDropdownData() {
            this.$http
                .get(
                    `/api/Dropdown/GetDynamicRegisterItems?fieldId=${this.model.dropdownDisplayMember}&selected=${this.value}
                    &updateTime=${this.model.fieldValue.updateTime ? new Date(this.model.fieldValue.updateTime).toISOString() : new Date().toISOString()}`
                )
                .then((result) => {
                    this.items = result.data;
                    this.populateStringValueById(this.selectedId);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: this.$t(
                            "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                        ),
                        text: this.$helpers.errorText(error),
                        color: "danger",
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.loaded = true;
                });
        },
        populateStringValueById(id) {
            // eslint-disable-next-line eqeqeq
            const val = this.items.filter((item) => item.id == id);
            if (val && val.length > 0) {
                this.model.fieldValue.stringValue = val[0].text;
            }
        },
        footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [
                        {
                            name: "dynamicRegisterDropdownSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        },
                    ],
                },
            };
        },
    },
    watch: {
        selectedId: function (newVal, oldVal) {
            this.model.fieldValue.intValue = newVal;
            this.$emit("input", newVal);
            RegisterEventBus.$emit('dynamic-field-change', newVal, oldVal, this.model);
            this.populateStringValueById(newVal);
        },
        value: function (newVal, oldVal) {
            this.selectedId = newVal;
        },
        required: function (val) {},
    },
    computed: {
        ...mapGetters(["isEnVersion", "nomDropdownSettings"]),
    },
    mounted() {
        if (!this.model.isMultiDropdown) {
            this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;
            this.loadDropdownData();
        }
    },
};
</script>
